export class CompositionResult {
    networkStatus;
    validationErrors;
    isShopOwner;
    shopId;
    tokens;
    request;
    rewardsKey;
    logger;

    success = (composition) => {
        if(!composition || composition === undefined){
            return false;
        }
        const success = composition.networkStatus['authorization'] === 200
            && composition.networkStatus['shop'] === 200
            && composition.networkStatus['profile'] === 200
            && (composition.networkStatus['created'] === 200 || composition.networkStatus['created'] === 201);

          
        if (composition.isDebug) {
            composition.logger.logTrace(`Composition Status: ${CompositionResult.logStatus(composition)}`);          
        }

        return success;
    }
    
    readyToAssociate = (composition) => {

        if(!composition || composition === undefined){
            return false;
        }
        const ready = composition.networkStatus['authorization'] === 200
            && composition.networkStatus['shop'] === 200
            && composition.networkStatus['profile'] === 200;
            
        if (composition.isDebug) {
            composition.logger.logTrace(`Ready to create association: ${CompositionResult.logStatus(composition)}`);
        }
        return ready;
    }

    isAuthorized = () => {
        return (
            this.networkStatus['authorization'] === 200 &&
            this.tokens &&
            this.tokens.access_token !== undefined &&
            this.tokens.access_token.length > 1);
    }

    static logStatus = (composition) => {
        return `
         AUTH: ${composition.networkStatus['authorization']}
         SHOP:${composition.networkStatus['shop']}
         PROFILE: ${composition.networkStatus['profile']}
         CREATED: ${composition.networkStatus['created']}`;
    }
    
    constructor(logService, request, rewardsKey) {
        this.logger = logService;
        this.rewardsKey = rewardsKey;
        this.request = request;
        this.tokens = {};
        this.validationErrors = [];
        this.shopId = 0;
        this.isShopOwner = false;
        this.networkStatus = {
            authorization: 0,
            shop: 0,
            profile: 200,
            created: 0
        };
        this.isDebug = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';

    }
}
export default CompositionResult;


// WEBPACK FOOTER //
// ./src/modules/account-connector/compositionResult.js